import React from 'react'
import Navbar from "../main_website/Navbar";
import Banner from './Banner'
import Hill from './Hill';
import PlanStat from './PlanStat';
import TourTypes from './TourTypes';
import CenterMain from './CenterMain';
import Aminities from './Aminities';
import HomeAbout from './HomeAbout';
import AllProjects from './AllProjects';
import HomeVideo from './HomeVideo';
import Whatsapp from './Whatsapp';
import Footer from "../main_website/Footer"






const Home = () => {
  return (
    <div>
      <Navbar />

      <Banner /> <br />
      <CenterMain /><hr /><br /><br />
      <Aminities />
      <AllProjects />
      <HomeAbout />
      <HomeVideo />
      {/* <FeaturedProperties/>
       <UpComingProjects/> */}
      {/* <ColonySection/> */}
      <PlanStat /><br />
      <Hill />


      <TourTypes /><br /><br />
      <br /><br />


      <br /><br />

       <Whatsapp />
      <Footer />
    </div>
  )
}

export default Home
